import { EnumTypeValue } from "@/shared/types";

/**
 * User roles in the application
 */
export const UserRole = {
    ADMIN: "admin",
    REGIEVOERDER: "regievoerder",
    KLANTENSERVICE: "klantenservice",
    TRANSVISION: "transvision",
    DEWIT: "dewit",
    SUPPORTCONSULTANT: "supportconsultant",
    VRIJWILLIGER: "vrijwilliger",
    ALLEENLEZEN: "alleenlezen",
} as const;

export type UserRole = EnumTypeValue<typeof UserRole>;

/**
 * A (now) sorted list of all roles in the application.
 */
export const allRoles = [
    UserRole.ADMIN,
    UserRole.REGIEVOERDER,
    UserRole.KLANTENSERVICE,
    UserRole.TRANSVISION,
    UserRole.DEWIT,
    UserRole.SUPPORTCONSULTANT,
    UserRole.VRIJWILLIGER,
    UserRole.ALLEENLEZEN,
];
